import React from 'react';
import { QuoteIcon, StarIcon, ExternalLinkIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 12 — REVIEWS / CLIENT EXPERIENCE · [Trust] [Conversion]
// Real Google review excerpts only AFTER permission + verification.
// No carousel, no fabricated names/quotes. Placeholders marked for verification.
// testimonials{name,quote,role,rating,source}
// Real, verbatim Google reviews published on separoviclawyers.com/testimonials.
// Quotes are exact (not paraphrased). Confirm ongoing display permission before publish.
const testimonials: {
  name: string;
  quote: string;
  role: string;
  rating: number;
  source: string;
}[] = [{
  name: 'Candice Van-Ross',
  quote: 'I had a fantastic experience with Tony Separovic injury lawyer. He was extremely professional, supportive, and always took the time to explain things clearly to me. He guided me through the entire process, kept me updated, and made what could have been a stressful situation so much easier. Thanks to his hard work and dedication, my claim was successfully settled, and I couldn’t be happier with the outcome.',
  role: 'Google review',
  rating: 5,
  source: 'https://separoviclawyers.com/testimonials/'
}, {
  name: 'Darren Kuhn',
  quote: 'I got a great result with my claim, it exceeded my expectations by quite a lot of money. Very happy with the result — thank you to the Separovic team.',
  role: 'Google review',
  rating: 5,
  source: 'https://separoviclawyers.com/testimonials/'
}, {
  name: 'Rob Mandanici',
  quote: 'Great firm to deal with, empathetic team who were firm with their advice, understanding of the issues and helpful along the way. Would highly recommend to anyone seeking any legal advice or representation in personal injury situations.',
  role: 'Google review',
  rating: 5,
  source: 'https://separoviclawyers.com/testimonials/'
}];
export function Testimonials() {
  const [featured, ...supporting] = testimonials;
  return <Section id="reviews" className="bg-canvas" data-id="element-583">
      <SectionHeading eyebrow="Client experience" title="What Clients Say" intro="Real, unedited Google reviews from people we have helped. Rated 4.6 from 231 Google reviews." data-id="element-584" />

      <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-585">
        {/* Featured review — dark forest card for emphasis */}
        <figure className="flex flex-col rounded-card bg-forest p-8 shadow-card-lg" data-id="element-586">
          <QuoteIcon aria-hidden="true" className="h-8 w-8 text-gold" strokeWidth={1.25} data-id="element-587" />
          <blockquote className="mt-4 font-serif text-h4 leading-[1.5] text-paper" data-id="element-588">
            “{featured.quote}”
          </blockquote>
          <figcaption className="mt-6 flex items-center justify-between border-t border-paper/15 pt-5" data-id="element-589">
            <div data-id="element-590">
              <p className="text-body font-semibold text-paper" data-id="element-591">
                {featured.name}
              </p>
              <p className="text-small text-paper/60" data-id="element-592">{featured.role}</p>
            </div>
            {featured.rating !== null && <span className="flex" aria-label={`${featured.rating} out of 5`} data-id="element-593">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" strokeWidth={0} data-id="element-594" />)}
              </span>}
          </figcaption>
        </figure>

        {/* Supporting reviews */}
        <div className="grid grid-cols-1 gap-5" data-id="element-595">
          {supporting.map((t, i) => <figure key={i} className="flex flex-col rounded-card border border-ink/5 bg-paper p-6 shadow-card" data-id="element-596">
              <span className="flex" aria-label={`${t.rating} out of 5`} data-id="element-597">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 fill-gold text-gold" strokeWidth={0} data-id="element-598" />)}
              </span>
              <blockquote className="mt-3 text-body text-ink" data-id="element-599">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center justify-between" data-id="element-600">
                <div data-id="element-601">
                  <p className="text-body font-semibold text-forest" data-id="element-602">
                    {t.name}
                  </p>
                  <p className="text-small text-slate/60" data-id="element-603">{t.role}</p>
                </div>
                <a href={t.source} className="inline-flex items-center gap-1 rounded text-small text-forest hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-604">
                  Source
                  <ExternalLinkIcon aria-hidden="true" className="h-3.5 w-3.5" strokeWidth={1.75} data-id="element-605" />
                </a>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </Section>;
}